<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;" ref="aaaa">
      <el-form :inline="true" :model="filters">
        <el-form-item>
          <el-input v-model="filters.keywords" placeholder="关键字"></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model.number="filters.workItemType" placeholder="状态">
            <el-option label="全部" :value="-1"></el-option>
            <el-option label="新建" :value="0"></el-option>
            <el-option label="已通过" :value="1"></el-option>
            <el-option label="已拒绝" :value="2"></el-option>
            <el-option label="待决定" :value="3"></el-option>
            <el-option label="已加入开发计划" :value="4"></el-option>
            <el-option label="已完成未发布" :value="5"></el-option>
            <el-option label="已发布" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getWorkItems">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addWorkItem">新增</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="exportExcel">导出Excel</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="setStatusBegin" v-show="this.sels.length>0">状态变更</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="workItems" highlight-current-row v-loading="listLoading" @selection-change="selsChange" style="width: 100%;" @sort-change="sortchange" :height="bodyHeight-220">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column type="index" width="60">
      </el-table-column>
      <el-table-column prop="workItemType" label="类型" width="80" :formatter="formatWorkItemType" sortable="custom">
      </el-table-column>
      <el-table-column prop="workItemNo" label="编号" width="110" sortable="custom">
      </el-table-column>
       <el-table-column prop="title" label="标题" min-width="200" sortable="custom">
      </el-table-column>      
      <el-table-column prop="status" label="状态" width="120" :formatter="formatStatus" sortable="custom">
      </el-table-column>
      <el-table-column prop="createUserName" label="创建人" width="100" sortable="custom">
      </el-table-column>      
      <el-table-column prop="createDate" label="创建日期" width="160" sortable="custom" :formatter="formatdate">
      </el-table-column>
      <el-table-column label="操作" width="220">
        <template scope="scope">
          <el-button size="small" @click="editWorkItem(scope.$index, scope.row)">编辑</el-button>
          <el-button type="success" size="small" @click="reviewWorkItem(scope.$index, scope.row)">评审</el-button>
          <el-button type="danger" size="small" @click="delWorkItem(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination layout="prev, pager, next" @current-change="pageChange" :page-size="pagesize" :total="records" style="float:right;">
    </el-pagination>

    <!--新增界面-->
    <el-dialog :title="workItemTitle" :visible.sync="addFormVisible" :close-on-click-modal="false" size="tiny">
      <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
        <el-form-item label="类型" prop="workItemType">
          <el-select v-model.number="addForm.workItemType" placeholder="请选择类型" :disabled="isReview">
            <el-option label="需求" :value="0"></el-option>
            <el-option label="优化" :value="1"></el-option>
            <el-option label="bug" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="标题" prop="title">
          <el-input v-model="addForm.title"  placeholder="请输入标题" :readonly="isReview"></el-input>
        </el-form-item>        
        <el-form-item label="来源客户" prop="sourceCustomerName">
          <el-input v-model="addForm.sourceCustomerName"  placeholder="请输入详细内容" :readonly="isReview"></el-input>
        </el-form-item>
        <el-form-item label="详细内容" prop="content">
          <el-input v-model="addForm.content" type="textarea" placeholder="请输入详细内容" :readonly="isReview" maxlength="2000" show-word-limit :autosize="{ minRows: 4, maxRows: 10}"></el-input>
        </el-form-item>
        <el-form-item label="业务背景" prop="story">
          <el-input v-model="addForm.story" type="textarea" placeholder="请输入业务背景" :readonly="isReview" maxlength="2000" show-word-limit :autosize="{ minRows: 4, maxRows: 10}"></el-input>
        </el-form-item>
        <el-form-item label="图片备注" prop="imgs">
          <ImagePaste :autoupload="true" :readonly="isReview" v-model="addForm.imagesRemark"></ImagePaste>
        </el-form-item>
        <el-form-item label="评审结果" prop="status" ref="reviewStatus" v-show="isReview">
          <el-radio-group v-model.number="addForm.status">
            <el-radio-button :label="1">同意</el-radio-button>
            <el-radio-button :label="2">拒绝</el-radio-button>
            <el-radio-button :label="3">待决定</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="评审意见" prop="reviewComment" ref="reviewComment" v-show="isReview">
          <el-input v-model="addForm.reviewComment" type="textarea" placeholder="请输入评审意见" maxlength="2000" show-word-limit :autosize="{ minRows: 4, maxRows: 10}"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="saveWorkItem" :loading="addLoading">保存</el-button>
        <el-button @click.native="addFormVisible = false">取消</el-button>
      </div>
    </el-dialog>

    <!--设置状态界面-->
    <el-dialog title="设置状态" :visible.sync="setStatusVisible" :close-on-click-modal="false" width="20%">
      <el-form :model="setStatusForm" label-width="120px" :rules="setStatusRules" ref="setStatusForm">
        <el-form-item label="状态" prop="status">
          <el-select v-model.number="setStatusForm.status" placeholder="状态" @change="setStatusChange">
            <el-option label="新建" :value="0"></el-option>
            <el-option label="已通过" :value="1"></el-option>
            <el-option label="已拒绝" :value="2"></el-option>
            <el-option label="待决定" :value="3"></el-option>
            <el-option label="已加入开发计划" :value="4"></el-option>
            <el-option label="已完成未发布" :value="5"></el-option>
            <el-option label="已发布" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-show="setStatusDateVisible" :label="setStatusDateTitle" prop="statusDate">
          <el-date-picker
            v-model="setStatusForm.statusDate"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="setStatusEnd" :loading="addLoading">保存</el-button>
        <el-button @click.native="setStatusVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import ImagePaste from '@/components/ImagePaste.vue'

export default {
  components: { ImagePaste },
  name: 'workItemManage',
  props: ['bodyHeight'],
  data() {
    return {
      filters: {
        keywords: '',
        workItemType: -1
      },
      sels: [],
      listLoading: false,
      sortname: 'createDate',
      sorttype: 'desc',
      pagesize: 20,
      pageno: 1,
      records: 0,
      totalpages: 0,
      workItems: [
      ],
      workItemTitle: '新增',
      isEditModel: false,
      isReview: false,
      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      addFormRules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ]
      },
      // 新增界面数据
      addForm: {
        workItemId: 0,
        workItemType: 0,
        sourceCustomerName: '',
        title: '',
        content: '',
        story: '',
        imagesRemark: [],
        reviewComment: ''
      },
      setStatusVisible: false,
      setStatusDateTitle: '日期',
      setStatusDateVisible: false,
      setStatusForm: {
        status: 0,
        statusDate: ''
      },
      setStatusRules: {
        statusDate: [
          {
            validator: (rule, value, callback) => {
              if (!value && (this.setStatusForm.status === 4 || this.setStatusForm.status === 6)) {
                callback(new Error('请输入日期'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    formatdate: function(row, col, value) {
      return new Date(value).Format('yyyy-MM-dd hh:mm:ss')
    },
    // 状态显示转换
    formatStatus: function(row) {
      if (row.status === 0) {
        return '新建'
      } else if (row.status === 1) {
        return '已通过'
      } else if (row.status === 2) {
        return '已拒绝'
      } else if (row.status === 3) {
        return '待决定'
      } else if (row.status === 4) {
        return '已加入开发计划'
      } else if (row.status === 5) {
        return '已完成未发布'
      } else if (row.status === 6) {
        return '已发布'
      } else {
        return '未知'
      }
    },
    // 类型显示转换
    formatWorkItemType: function(row) {
      if (row.workItemType === 0) {
        return '需求'
      } else if (row.status === 1) {
        return '优化'
      } else if (row.status === 2) {
        return 'bug'
      } else {
        return '未知'
      }
    },
    // 获取工作项列表
    getWorkItems: function() {
      let para = {
        keywords: this.filters.keywords,
        workItemType: this.filters.workItemType,
        pageno: this.pageno,
        pagesize: this.pagesize,
        sortname: this.sortname,
        sorttype: (this.sorttype === 'ascending' ? 'asc' : 'desc')
      }

      this.$ajax({
        url: 'api/WorkItem/GetworkItems',
        method: 'get',
        data: para,
        loadingName: 'listLoading',
        success: (d, r) => {
          let { records, totalpages } = r
          this.workItems = d
          this.records = records
          this.totalpages = totalpages
        }
      })
    },
    pageChange: function(val) {
      this.pageno = val
      this.getworkItems()
    },
    sortchange: function(sort) {
      this.sortname = sort.prop
      this.sorttype = sort.order
      this.getworkItems()
    },
    addWorkItem: function() {
      this.workItemTitle = '需求新增'
      this.isEditModel = false
      this.isReview = false
      this.addFormVisible = true
      this.addForm = {
        workItemId: 0,
        workItemType: 0,
        sourceCustomerName: '',
        title: '',
        content: '',
        story: '',
        imagesRemark: []
      }

      if (this.$refs['addForm']) {
        this.$refs['addForm'].resetFields()
      }
    },
    saveWorkItem: function() {
      if (this.isReview) {
        let para = { workItemId: this.addForm.workItemId, status: this.addForm.status }
        this.$ajax({
          url: 'api/WorkItem/ReviewWorkItem',
          data: JSON.stringify(para),
          loadingName: 'addLoading',
          success: (response) => {
            this.$message({
              message: '保存成功',
              type: 'success',
              duration: 1000
            })
            this.$refs['addForm'].resetFields()
            this.addFormVisible = false
            this.getWorkItems()
          }
        })
      } else {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            let para = Object.assign({}, this.addForm)
            para.imagesRemark = JSON.stringify(para.imagesRemark)
            this.$ajax({
              url: 'api/WorkItem/SaveWorkItem',
              data: JSON.stringify(para),
              loadingName: 'addLoading',
              success: (response) => {
                this.$message({
                  message: '保存成功',
                  type: 'success',
                  duration: 1000
                })
                this.$refs['addForm'].resetFields()
                this.addFormVisible = false
                this.getWorkItems()
              }
            })
          }
        })
      }
    },
    editWorkItem: function(index, row) {
      this.workItemTitle = '需求编辑'
      this.isEditModel = true
      this.isReview = false
      this.addFormVisible = true

      this.$ajax({
        url: 'api/WorkItem/GetWorkItem',
        data: {workItemId: row.workItemId},
        loadingName: 'addLoading'
      }).then((res) => {
        res.data.imagesRemark = JSON.parse(res.data.imagesRemark)
        this.addForm = res.data
        this.$refs.addForm.resetFields()
      })
    },
    delWorkItem: function(index, row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let para = [row.workItemId]
        this.$ajax({
          url: 'api/WorkItem/DeleteWorkItems',
          data: JSON.stringify(para),
          loadingName: 'listLoading'
        }).then((res) => {
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getWorkItems()
        })
      }).catch(() => {
      })
    },
    reviewWorkItem: function(index, row) {
      this.workItemTitle = '需求评审'
      this.isEditModel = true
      this.isReview = true
      this.addFormVisible = true

      this.$ajax({
        url: 'api/WorkItem/GetWorkItem',
        data: {workItemId: row.workItemId},
        loadingName: 'addLoading'
      }).then((res) => {
        res.data.imagesRemark = JSON.parse(res.data.imagesRemark)
        res.data.status = 1
        this.addForm = res.data
      })
    },
    setStatusBegin: function() {
      this.setStatusVisible = true
      this.setStatusDateVisible = false
      this.setStatusForm = {
        status: 0,
        statusDate: ''
      }

      if (this.$refs['setStatusForm']) {
        this.$refs['setStatusForm'].resetFields()
      }
    },
    setStatusEnd: function() {
      this.$refs.setStatusForm.validate((valid) => {
        if (valid) {
          let para = Object.assign({WorkItemIds: this.sels.map(u => u.workItemId)}, this.setStatusForm)
          this.$ajax({
            url: 'api/WorkItem/SetWorkItemStatus',
            method: 'post',
            data: JSON.stringify(para),
            loadingName: 'addLoading'
          }).then((res) => {
            this.setStatusVisible = false
            this.$message({
              message: '启用成功',
              type: 'success'
            })
            this.getWorkItems()
          })
        }
      })
    },
    setStatusChange: function(sel) {
      if (sel === 4) {
        this.setStatusDateTitle = '计划发布日期'
        this.setStatusDateVisible = true
      } else if (sel === 6) {
        this.setStatusDateTitle = '实际发布日期'
        this.setStatusDateVisible = true
      } else {
        this.setStatusDateVisible = false
      }
    },
    selsChange: function(sels) {
      this.sels = sels
    },
    exportExcel: function() {
      var urlc = 'api/WorkItem/ExportExcel?keywords=' + this.filters.keywords + '&workItemType=' + this.filters.workItemType
      location.href = urlc
      // var a = document.createElement('a')
      // a.download = '需求清单.xlsx'
      // a.href = urlc
      // a.click()
    }
  },
  mounted() {
    this.getWorkItems()
  }
}
</script>

